<template>
  <div class="wrapper"></div>
</template>

<script type="text/ecmascript-6">
import { getSchemeUrl }from '../service/api_scheme.js'
const expire_day = 2;//距离过期多少天刷新
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {
    // const name = this.$route.query.name;
    // if(name == '115'){
    //   window.location.href = "weixin://dl/business/?t=NIWLhO5wNIn";
    // }else if(name == '115_sh'){
    //   window.location.href = "weixin://dl/business/?t=IE98tDORD3t";
    // }else if(name == '800'){
    //   window.location.href = "weixin://dl/business/?t=ZkoDGHVHYsn";
    // }
    const {scheme_id,name} = this.$route.query;
    const finParam = scheme_id || name;
    this.getUrlScemeEvent(finParam);
  },
  mounted() {},
  computed: {},
  methods: {
    judgeLocalScheme(finParam){
      const localSchemeStr = localStorage.getItem(finParam);
      if(localSchemeStr){
          const localSchemeDic = JSON.parse(localSchemeStr);
          const now_timestamp = new Date().getTime();//毫秒
          const { expire_time,openlink} = localSchemeDic;//秒
          const diff_timeStamp = expire_time - now_timestamp / 1000
          return {
            isExpire:diff_timeStamp/(3600*24) < expire_day,
            localOpenlink:openlink
          }
      }else{
        return {
          isExpire:true,
          localOpenlink:''
        }
      }
    },
    async getUrlScemeEvent(finParam){
      const {isExpire,localOpenlink} = this.judgeLocalScheme(finParam);
      console.log(isExpire,localOpenlink);
      if(!isExpire){
        window.location.href = localOpenlink;
      }else{
        const res = await getSchemeUrl({scheme_id:finParam});
        console.log(res.data);
        if(res.data.code === 0){
          const {scheme_id,openlink,expire_time} = res.data.data
          const str = JSON.stringify({
            openlink,
            expire_time,
            scheme_id
          })
          localStorage.setItem(scheme_id,str);
          window.location.href = openlink;
        }
      }
    }
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
